var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    transform: "translate(0.5)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7727,
    cy: 16.6279,
    rx: 15.2727,
    ry: 15.6279,
    fill: "#EAF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5918 12.0234V18.4234C25.5918 18.8478 25.7393 19.2547 26.0018 19.5548C26.2644 19.8549 26.6205 20.0234 26.9918 20.0234H32.5918",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5918 12.0234V18.4234C25.5918 18.8478 25.7393 19.2547 26.0018 19.5548C26.2644 19.8549 26.6205 20.0234 26.9918 20.0234H32.5918",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0327 40.0697H15.0055C14.2084 40.0697 13.4439 39.7381 12.8803 39.1479C12.3166 38.5577 12 37.7571 12 36.9224V14.8914C12 14.0567 12.3166 13.2562 12.8803 12.666C13.4439 12.0757 14.2084 11.7441 15.0055 11.7441H25.5245L33.0382 19.6124V36.9224C33.0382 37.7571 32.7215 38.5577 32.1579 39.1479C31.5943 39.7381 30.8298 40.0697 30.0327 40.0697Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5371 34.209H19.7517",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5371 26.4736H26.3953",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5371 30.3027H26.3953",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2053 16.2374C17.4145 16.2374 16.7734 16.7622 16.7734 17.4095C16.7734 18.0568 17.2507 18.5816 18.2053 18.5816C19.1598 18.5816 19.6371 19.1064 19.6371 19.7537C19.6371 20.401 18.996 20.9258 18.2053 20.9258M18.2053 16.2374C18.7352 16.2374 19.1979 16.4731 19.4455 16.8235M18.2053 16.2374V15.6514M18.2053 20.9258L18.2053 21.5118M18.2053 20.9258C17.6753 20.9258 17.2126 20.6901 16.965 20.3397",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.edabf8e0a135b07d29d3d12f19e8ea9b.svg";
export { ForwardRef as ReactComponent };